module.exports = __webpack_public_path__ + "img/no-image.9c3a64e2.png";